import { Col, Divider, Modal, notification, Row } from 'antd';
import classNames from 'classnames/bind';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import orderAPI from '~/api/OrderAPI';
import { IMAGES } from '~/assets/assetsPath';
import { getNumberWithCommas } from '~/utils';
import CancelModal from '../FormCancel';
import DoubleModal from '../FormDouble';
import styles from './DetailInfoOrder.module.scss';

const cx = classNames.bind(styles);

const Item = styled.div`
    .ant-divider-horizontal {
        margin: 14px 0px;
    }
`;

const DetailInfoOrder = ({ item, handleGetOrderInfo }) => {
    const navigate = useNavigate();
    const [isShowCancelOrderModal, setIsShowCancelOrderModal] = useState(false);
    const handleShowCancelOrderModal = () => {
        setIsShowCancelOrderModal(true);
    };
    const onRejectCancelOrder = () => {
        setIsShowCancelOrderModal(false);
    };
    const onAgreeCancelOrder = async () => {
        try {
            await orderAPI.cancelOrderAPI(item.id);
            notification.open({
                message: 'Order canceled successfully',
                duration: 2,
                placement: 'top',
            });
            await handleGetOrderInfo();
            await setIsShowCancelOrderModal(false);
        } catch (err) {
            console.log(err);
            if (err.message) {
                notification.open({
                    message: err.message,
                    duration: 2,
                    placement: 'top',
                });
            }
        }
    };

    const [isShowCompleteOrder, setIsShowCompleteOrder] = useState(false);
    // const handleShowCompleteOrder = () => {
    //     setIsShowCompleteOrder(true);
    // };
    const onRejectCompleteOrder = () => {
        setIsShowCompleteOrder(false);
    };
    const onAgreeCompleteOrder = async () => {
        try {
            await orderAPI.receiveOrderAPI(item.id);
            notification.open({
                message: 'Received goods successfully',
                duration: 2,
                placement: 'top',
            });
            await handleGetOrderInfo();
            await setIsShowCompleteOrder(false);
        } catch (err) {
            console.log(err);
            if (err.message) {
                notification.open({
                    message: err.message,
                    duration: 2,
                    placement: 'top',
                });
            }
        }
    };

    const [isShowDoubleOrderModal, setIsShowDoubleOrderModal] = useState(false);
    const handleShowDoubleOrderModal = (data) => {
        if (data?.order_online) {
            setIsShowDoubleOrderModal(true);
        } else {
            // notification.open({
            // message: 'You cannot repurchase this order!',
            //     duration: 2,
            //     placement: 'top',
            // });
        }
    };
    const onRejectDoubleOrder = () => {
        setIsShowDoubleOrderModal(false);
    };
    const onAgreeDoubleOrder = () => {
        if (item.order_type === 'PRODUCT') {
            navigate(`/dat-hang-lai/${item.id}`);
        } else {
            navigate(`/dat-goi-dich-vu-lai/${item.id}`);
        }
        setIsShowDoubleOrderModal(false);
    };

    const handleNavigateDetail = (data, type) => {
        if (type === 'PRODUCT') {
            navigate(`/thong-tin-san-pham/${data.product.id}`);
        }
        if (type === 'COMBO') {
            navigate(`/goi-dich-vu-chi-tiet/${data.combo_service_id}`);
        }
    };

    return (
        <Item>
            <div className={cx('container')}>
                <Row align="middle" className={cx('name_section')}>
                    order information
                </Row>

                <Divider style={{ borderTop: '2px solid rgba(0,0,0,.06)' }} />
                {item?.order_items?.length
                    ? item.order_items?.map((product, index) => {
                        return (
                            <>
                                <Row
                                    className={cx('service')}
                                    key={index}
                                    onClick={() => handleNavigateDetail(product, item.order_type)}
                                >
                                    <Col xs={6} xl={5}>
                                        <Row className={cx('image')}>
                                            <img
                                                src={product.thumbnail || product.image[0] || IMAGES.ImagePlaceholder}
                                                alt=""
                                            />
                                            {/* {item.order_type === 'PRODUCT' && (
                                                  <img src={product.thumbnail || IMAGES.ImagePlaceholder} alt="" />
                                              )}
                                              {item.order_type === 'COMBO' && (
                                                  <img src={product.image[0] || IMAGES.ImagePlaceholder} alt="" />
                                              )} */}
                                        </Row>
                                    </Col>
                                    <Col xs={18} xl={19} className={cx('content')}>
                                        <div>
                                            <Row className={cx('name')}>{product.title}</Row>
                                            <Row className={cx('type')}>
                                                <span>{product.product?.category?.title}</span>
                                            </Row>
                                            <Row align="middle">
                                                <Col xs={2}>
                                                    <Row className={cx('type')}>x{product.quantity}</Row>
                                                </Col>
                                                <Col xs={22}>
                                                    <Row className={cx('right_content')}>
                                                        {parseInt(product.discount_price) ||
                                                            product.product.price !== product.price ? (
                                                            <div className={cx('old_price')}>
                                                                <del>
                                                                    {getNumberWithCommas(
                                                                        product.product.price || product.price,
                                                                    )}
                                                                    d
                                                                </del>
                                                            </div>
                                                        ) : null}
                                                        <div className={cx('new_price')}>
                                                            {getNumberWithCommas(
                                                                product.price - parseInt(product.discount_price),
                                                            )}
                                                            d
                                                        </div>
                                                    </Row>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Col>
                                </Row>
                                <Divider style={{ borderTop: '2px solid rgba(0,0,0,.06)' }} />
                            </>
                        );
                    })
                    : null}
                {Number(item?.discount) ? (
                    <Row className={cx('total_price')}>
                        <Col xs={12}>
                            <Row className={cx('title')}>Reduced:</Row>
                        </Col>
                        <Col xs={12}>
                            <Row justify="end" className={cx('price')}>
                                - {getNumberWithCommas(item.discount)} d
                            </Row>
                        </Col>
                    </Row>
                ) : null}
                <Row className={cx('total_price')}>
                    <Col xs={12}>
                        <Row className={cx('title')}>Total amount:</Row>
                    </Col>
                    <Col xs={12}>
                        <Row justify="end" className={cx('price')}>
                            {getNumberWithCommas(item.total_cost)} d
                        </Row>
                    </Col>
                </Row>
                <Row className={cx('footer')} align="middle">
                    <Col xs={12} className={cx('payment')}>
                        {/* <Row className={cx('title')}>Payment method:</Row> */}
                        <Row className={cx('content')}>
                            {item.payment_type === 'CASH'
                                ? 'Payment in cash'
                                : 'Pay with service limit wallet'}
                        </Row>
                    </Col>
                    <Col xs={12}>
                        <Row justify="end">
                            {/* <div className={cx('btn', 'detail')} onClick={handelShowDoubleBookingModal}>
                        Reset
                    </div> */}
                            {/* {(item.activity === 'WAITING' || item.activity === 'CONFIRMED') && (
                                <div className={cx('btn', 'cancel')} onClick={handleShowCancelOrderModal}>
                                    Cancel order
                                </div>
                            )} */}
                            {/* {item.activity === 'PROCESSING' && (
                                <div className={cx('btn', 'cancel')} onClick={handleShowCompleteOrder}>
                                    Has received the goods
                                </div>
                            )} */}
                            {/* {item.activity === 'WAITING' && (
                                <div className={cx('btn', 'cancel')} onClick={handleShowCancelOrderModal}>
                                    Cancel order
                                </div>
                            )} */}

                            {(item.activity === 'WAITING' || item.activity === 'CONFIRMED') && (
                                <div className={cx('btn', 'cancel')} onClick={handleShowCancelOrderModal}>
                                    Cancel order
                                </div>
                            )}
                            {(item.activity === 'COMPLETED' || item.activity === 'CANCELED') && item?.order_online && (
                                <div className={cx('btn', 'cancel')} onClick={() => handleShowDoubleOrderModal(item)}>
                                    Repurchase
                                </div>
                            )}
                        </Row>
                    </Col>
                </Row>
            </div>
            {isShowCancelOrderModal && (
                <Modal
                    centered
                    visible={isShowCancelOrderModal}
                    onCancel={() => setIsShowCancelOrderModal(false)}
                    maskClosable={false}
                    footer={null}
                    className="otp-modal"
                    width={500}
                >
                    <div style={{ padding: '20px 20px' }}>
                        <CancelModal
                            onAgreeCancel={onAgreeCancelOrder}
                            onRejectCancel={onRejectCancelOrder}
                            text="Do you want to cancel this order?"
                        />
                    </div>
                </Modal>
            )}

            {isShowCompleteOrder && (
                <Modal
                    centered
                    visible={isShowCompleteOrder}
                    onCancel={() => setIsShowCompleteOrder(false)}
                    maskClosable={false}
                    footer={null}
                    className="otp-modal"
                    width={500}
                >
                    <div style={{ padding: '20px 20px' }}>
                        <CancelModal
                            onAgreeCancel={onAgreeCompleteOrder}
                            onRejectCancel={onRejectCompleteOrder}
                            text="Have you received this order?"
                        />
                    </div>
                </Modal>
            )}

            {isShowDoubleOrderModal && (
                <Modal
                    centered
                    visible={isShowDoubleOrderModal}
                    onCancel={() => setIsShowDoubleOrderModal(false)}
                    maskClosable={false}
                    footer={null}
                    className="otp-modal"
                    width={500}
                >
                    <div style={{ padding: '20px 20px' }}>
                        <DoubleModal
                            onAgreeDouble={onAgreeDoubleOrder}
                            onRejectDouble={onRejectDoubleOrder}
                            text="Do you want to reset this order?"
                        />
                    </div>
                </Modal>
            )}
        </Item>
    );
};

export default DetailInfoOrder;
